// extracted by mini-css-extract-plugin
module.exports = {"header":"Flexi_header__3NgZP","form":"Flexi_form__2PCnk"};